export function ActionButton({
  className = "",
  variant = "secondary",
  size = "md",
  children,
  ...props
}) {
  return (
    <button
      className={["ui-action-button", className].filter(Boolean).join(" ")}
      data-variant={variant}
      data-size={size}
      type={props.type || "button"}
      {...props}
    >
      {children}
    </button>
  );
}

export function IconButton({
  className = "",
  variant = "ghost",
  size = "md",
  children,
  ...props
}) {
  return (
    <button
      className={["ui-icon-button", className].filter(Boolean).join(" ")}
      data-variant={variant}
      data-size={size}
      type={props.type || "button"}
      {...props}
    >
      {children}
    </button>
  );
}

export function FieldShell({ className = "", label, htmlFor, children }) {
  return (
    <label className={["ui-field-shell", className].filter(Boolean).join(" ")} htmlFor={htmlFor}>
      {label ? <span>{label}</span> : null}
      {children}
    </label>
  );
}

export function ListItemSurface({
  as: Element = "div",
  className = "",
  active = false,
  children,
  onClick,
  onKeyDown,
  ...props
}) {
  const interactive = typeof onClick === "function";
  const nextProps = {
    ...props,
    className: ["ui-list-item-surface", className].filter(Boolean).join(" "),
    "data-state": active ? "active" : "idle",
    onClick,
    onKeyDown: (event) => {
      onKeyDown?.(event);
      if (!interactive || event.defaultPrevented) {
        return;
      }
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onClick(event);
      }
    },
  };

  if (interactive) {
    nextProps.role = props.role || "button";
    nextProps.tabIndex = props.tabIndex ?? 0;
  }

  return <Element {...nextProps}>{children}</Element>;
}

export function MediaTile({ className = "", active = false, children, ...props }) {
  return (
    <ListItemSurface
      as="article"
      className={["ui-media-tile", className].filter(Boolean).join(" ")}
      active={active}
      {...props}
    >
      {children}
    </ListItemSurface>
  );
}

export function PaginationButton({ className = "", active = false, children, ...props }) {
  return (
    <button
      className={["ui-pagination-button", className].filter(Boolean).join(" ")}
      data-state={active ? "active" : "idle"}
      type="button"
      {...props}
    >
      {children}
    </button>
  );
}

export function DialogShell({
  className = "",
  panelClassName = "",
  labelledBy,
  label,
  onClose,
  children,
}) {
  return (
    <div
      className={["auth-overlay", className].filter(Boolean).join(" ")}
      role="presentation"
      onMouseDown={onClose}
    >
      <section
        className={["auth-dialog", panelClassName].filter(Boolean).join(" ")}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        aria-label={label}
        onMouseDown={(event) => event.stopPropagation()}
      >
        {children}
      </section>
    </div>
  );
}
